import React, { Component } from 'react';
import wrapper from './blockDecorator';
import RenderBlocks from '~/components/editor/RenderBlocks';

const AsideBlock = props => {
  const { block, onAddChild, onChildAction } = props;

  switch (block.type) {

    // case 'html_editor_aside':
    //   return (
    //     <div
    //       className="static-html"
    //       dangerouslySetInnerHTML={{ __html: block.content.group_html[0].text }}
    //     />
    //   );

    case 'heading_level_1_aside':
      return (
        <h1 className="h1">
          {block.content.group_heading[0].title}
        </h1>
      );

    case 'heading_level_2_aside':
      return (
        <h2 className="h2">
          {block.content.group_heading[0].title}
        </h2>
      );

    case 'heading_level_3_aside':
      return (
        <h3 className="h3">
          {block.content.group_heading[0].title}
        </h3>
      );

    case 'image-aside':
      return (
        <img
          className="img"
          src={block.content.group_image[0].image}
        />
      );

    case 'image-link-aside':
      return (
        <a href={block.content.group_image[0].link_url}>
          <img
            className="img"
            src={block.content.group_image[0].image}
          />
        </a>
      );

    case 'html_editor_aside':
      return (
        <div
          className="clean-html"
          dangerouslySetInnerHTML={{ __html: block.content.group_html[0].text }}
        />
      );

    case 'buttons_aside':
      const buttons_mainbtn = block.content.group_buttons[0].btn_main_url ? (<a className="btn btn--primary" href={block.content.group_buttons[0].btn_main_url}>{block.content.group_buttons[0].btn_main_text}</a>) : null;
      const buttons_secondbtn = block.content.group_buttons[0].btn_second_url ? (<a className="btn btn--outline" href={block.content.group_buttons[0].btn_second_url}>{block.content.group_buttons[0].btn_second_text}</a>) : null;
      return (
        <div className="buttons">
          {buttons_mainbtn}
          {buttons_secondbtn}
        </div>
      );

    case 'video_aside':{
      const URL = block.content.group_video[0].video
        .replace('youtu.be/', 'youtube.com/watch?v=');
      return (
        <React.Fragment>
          <a className="video" href={URL}>
            <img src={block.content.group_video[0].video_prev} />
          </a>
          <p className="video_subtext">{block.content.group_video[0].text}</p>
        </React.Fragment>
      )}

    case 'hr_aside':
      return (
        <hr/>
      );

    case 'margin_aside':
      return (
        <div className="margin"/>
      );

    case 'margin-big_aside':
      return (
        <div className="margin--big"/>
      );

    case 'ul_grey_aside':
    case 'ol_grey_aside':
      return (
        <div className="back-grey">
          <div
            className="clean-html"
            dangerouslySetInnerHTML={{ __html: block.content.group_html[0].text }}
          />
        </div>
      );

    case 'ul_aside':
    case 'ol_aside':
      return (
        <div
          className="clean-html"
          dangerouslySetInnerHTML={{ __html: block.content.group_html[0].text }}
        />
      );

    case 'list_links_aside':
      return (
        <div className="aside-links">
          <div
            className="clean-html"
            dangerouslySetInnerHTML={{ __html: block.content.group_items[0].text }}
          />
        </div>
      );

    default:
      return (
        <p className="txt txt--red">Неизвестный формат блока: {block.type}</p>
      );
  }
};

export default wrapper(AsideBlock);
